import {UserModuleDb} from '@cp/model';
import {useCallback} from 'react';
import updateUserDoc from '../../api/user/updateUserDoc';
import getUserDoc from '../../api/user/getUserDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useAddSelectedModules() {
  const addSelectedModulesFn = useCallback(async (moduleId: string, _topics: string[]): Promise<void> => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    const user = await getUserDoc(uid);
    const current: UserModuleDb[] = (user?.selectedModules ?? []).map((m) => ({moduleId: m.moduleId}));
    const next: UserModuleDb[] = [...current.filter((m) => m.moduleId !== moduleId), {moduleId}];
    await updateUserDoc(uid, {selectedModules: next});
  }, []);

  const {loading, error, refetch} = useFunctionRun(addSelectedModulesFn, {
    skipLoadOnMount: true,
  });

  return {addSelectedModules: refetch, loading, error};
}
